import { NgModule } from '@angular/core';
import { Routes } from '@angular/router';

import { ShareModule} from '../../shared/share.module';

import { AuthGuard } from '../../service/auth-guard.service';

import { ProjectComponent } from './project/project.component';
import { ProjectCrudComponent } from './project-crud/project-crud.component';
import { ProjectListComponent } from './project-list/project-list.component';
import { ProjectsComponent } from './projects/projects.component';
import { PanelComponent } from './panel/panel.component';
import { ListPComponent } from './listP/listP.component';
import { PanelPComponent } from './panelP/panelP.component';

import { ProjectService } from './shared/project.service';

var permissionPage='admin.project';


export const ProjectServices:Array<any>=[ProjectService];
export const ProjectComponents:Array<any>=[PanelComponent,ListPComponent,PanelPComponent,ProjectListComponent,ProjectComponent,ProjectCrudComponent,ProjectsComponent];
export const ProjectRoutes: Routes = [
  { path: 'project', component: ProjectListComponent, canActivate: [AuthGuard], data: { 'fromRoute': true,page:permissionPage, operation: 'list'  } },
  { path: 'project/create', component: ProjectCrudComponent, canActivate: [AuthGuard], data: { 'fromRoute': true,page:permissionPage, operation: 'create' } },
  { path: 'project/:id', component: ProjectCrudComponent, canActivate: [AuthGuard], data: { 'fromRoute': true,page:permissionPage, operation: 'read' } },
  { path: 'project/:id/update', component: ProjectCrudComponent, canActivate: [AuthGuard], data: { 'fromRoute': true,page:permissionPage, operation: 'update' } },
  { path: 'project/:id/clone', component: ProjectCrudComponent, canActivate: [AuthGuard], data: { 'fromRoute': true,page:permissionPage, operation: 'clone' } }
];


@NgModule({
  imports: [ ShareModule ],
  declarations: [...ProjectComponents],
  providers: [ProjectService],
  exports: [...ProjectComponents]
})
export class ProjectModule { }



// WEBPACK FOOTER //
// ./src/app/module/project/project.module.ts